import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import SettlementListWrap from '../../views/settlement/components/SettlementListWrap';
import { balanceActions } from '../../store/modules/balance';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class BalanceListContainer extends Component {
  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getBalanceListExcelDownload, pageType, balanceList } = this.props;

    if (!balanceList || !balanceList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getBalanceListExcelDownload({
      searchOption: balanceList.searchOption,
      filterOption: balanceList.filterOption,
      sortOption: balanceList.sortOption,
      balanceStatus: pageType,
    });
  };

  /**
   *  정산 아이템 리스트 엑셀 다운로드
   */
  getBalanceItemListExcelDownload = () => {
    const { getBalanceItemListExcelDownload, pageType, balanceList } = this.props;

    if (!balanceList || !balanceList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getBalanceItemListExcelDownload({
      searchOption: balanceList.searchOption,
      filterOption: balanceList.filterOption,
      sortOption: balanceList.sortOption,
      balanceStatus: pageType,
    });
  };

  render() {
    const { setData, pageType, balanceList } = this.props;

    return (
      <SettlementListWrap
        type={pageType}
        setData={setData}
        pageType={pageType}
        balanceList={balanceList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
        getBalanceItemListExcelDownload={this.getBalanceItemListExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    balanceList: state.balance.balanceList,
    balanceListSummaryInfo: state.balance.balanceListSummaryInfo,
  };
};

const mapDispatchToProps = {
  setData: balanceActions.setData,
  getBalanceListExcelDownload: balanceActions.getBalanceListExcelDownload,
  getBalanceItemListExcelDownload: balanceActions.getBalanceItemListExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(BalanceListContainer));
